
import IconWrapper from './IconWrapper.vue';

export default {
  components: { IconWrapper }
};
